module.exports = __webpack_public_path__ + "site/img/heart.0d25753e.svg";